import { render, staticRenderFns } from "./MemoryGame.container.vue?vue&type=template&id=5a8c259c&scoped=true&"
import script from "./MemoryGame.container.vue?vue&type=script&lang=js&"
export * from "./MemoryGame.container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8c259c",
  null
  
)

export default component.exports